import color from "src/design-system/tokens/color";
import { tw } from "src/design-system/tw";
interface Props {
  className?: string;
}

export function DottedLine({ className }: Props) {
  return (
    <div
      className={tw(
        "relative z-2 mx-4 my-0 flex w-2.5 items-center justify-center",
        className,
      )}
    >
      <svg width="2" height="40" className="absolute">
        <line
          x1="1"
          y1="0"
          x2="1"
          y2="44"
          stroke={color.icon.secondary}
          strokeDashoffset="1"
          strokeWidth="2"
          strokeLinecap="round"
          strokeDasharray="0, 6"
        />
      </svg>
    </div>
  );
}
